// import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  modalImage();
  scrollEffect();
});



/* ----------------------------------
  　MV テキストストローク
---------------------------------- */

document.addEventListener("DOMContentLoaded", function () {
    const loadingScreen = document.getElementById("loading");
    const vivusTargetId = 'svgmask';
    const maskPath = document.getElementById("mask-line-path");

    const hasVisitedKey = 'hasVisitedThisSession';
    const delayBeforeFadeOutMs = 1000;

    // 初回訪問
    const hasVisited = sessionStorage.getItem(hasVisitedKey);

    // SVG があるページ
    const svgElement = document.getElementById(vivusTargetId);

    // -----------------------------------------------
    // 初回じゃない or SVG がない → ローディング即スキップ
    // -----------------------------------------------
    if (hasVisited || !svgElement) {
        if (loadingScreen) loadingScreen.style.display = 'none';
        document.body.style.opacity = 1;
        return;
    }

    // -----------------------------------------------
    // 初回＋SVG が存在するページ → ローディング実行
    // -----------------------------------------------
    document.body.style.opacity = 1;
    if (loadingScreen) loadingScreen.style.opacity = 1;
    if (maskPath) maskPath.style.opacity = 1;

    if (typeof Vivus !== 'undefined') {

        new Vivus(vivusTargetId, {
            type: 'oneByOne',
            start: 'manual',
            duration: 270,
            animTimingFunction: Vivus.LINEAR,
            forceRender: false
        }, function () {

            // 初回訪問フラグ
            sessionStorage.setItem(hasVisitedKey, 'true');

            setTimeout(() => {
                if (loadingScreen) {
                    loadingScreen.style.transition = 'opacity 0.6s ease-out';
                    loadingScreen.style.opacity = 0;
                    loadingScreen.addEventListener('transitionend', function handler() {
                        loadingScreen.style.display = 'none';
                        loadingScreen.removeEventListener('transitionend', handler);
                    });
                }
            }, delayBeforeFadeOutMs);
        }).play();

    } else {
        // Vivus 使えない時の fallback
        sessionStorage.setItem(hasVisitedKey, 'true');
        if (loadingScreen) loadingScreen.style.display = 'none';
    }
});


/* ----------------------------------
  　慣性スクロール
---------------------------------- */

const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);





/* ----------------------------------
　humberger menu
---------------------------------- */
window.addEventListener('load', () => {
  const navEle = document.querySelector('.hd_menu-toggle');
  const navWrap = document.querySelector('.hd_nav');
  const navItems = document.querySelectorAll('.hd_nav_li');

  navEle.addEventListener('click', () => {
    const isOpen = navWrap.classList.contains('is_open');

    if (!isOpen) {
      // 開くとき
      navWrap.classList.add('is_open');

      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.add('show');
          item.classList.remove('hide');
        }, i * 120);
      });

    } else {
      // 閉じるとき
      navItems.forEach((item, i) => {
        setTimeout(() => {
          item.classList.remove('show');
        }, i * 80);
      });

      // パネル自体も同時に左へスライド
      navWrap.classList.add('hide-panel');
      setTimeout(() => {
        navWrap.classList.remove('is_open', 'hide-panel');
      }, 500); // CSSトランジション時間に合わせる
    }

    navEle.classList.toggle('is_open', !isOpen);
  });
});




/* ----------------------------------
  　コンテンツ出現
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
const targets = document.querySelectorAll('.blur-in');

const options = {
  threshold: 0.2
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
    }
  });
}, options);

targets.forEach(target => observer.observe(target));
});
/* ----------------------------------
  　画像
---------------------------------- */
window.addEventListener('scroll', () => {
  // 画面幅が768px以下なら何もしない
  if (window.innerWidth <= 768) return;

  document.querySelectorAll('.business_skymetalroof_img img').forEach(img => {
    const rect = img.parentElement.getBoundingClientRect();
    const move = rect.top * -0.02; // 動きの強さ
    img.style.transform = `translateY(${move}px)`;
  });
});




/* ----------------------------------
  　画像　フェードイン
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.scroll-animate');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); // 一度だけアニメーション
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(target => observer.observe(target));
});

/* ----------------------------------
  　Home front_lead_image　白黒→カラー
---------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.front_lead_image');

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;

        // 遅延をつけて順番にカラー化
        images.forEach((el, i) => {
          if (el === img) {
            setTimeout(() => {
              el.classList.add('in-view');
            }, i * 100); // 0.15秒ずつずらす
          }
        });

        // observer から除外（1回だけ発火）
        obs.unobserve(img);
      }
    });
  }, { threshold: 0.5 }); // 30%見えたら発火

  images.forEach(img => observer.observe(img));
});


/* ----------------------------------
  　Company スライダー
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
if (!location.pathname.includes('company')) return;
  const slider = document.querySelector('.company_slider_content');

  // 画像を複製して無限ループ用に2倍にする
  slider.innerHTML += slider.innerHTML;

  let pos = 0;
  const speed = 0.6;

  function loop() {
    pos -= speed;
    slider.style.transform = `translateX(${pos}px)`;

    if (Math.abs(pos) >= slider.scrollWidth / 2) {
      pos = 0;
    }

    requestAnimationFrame(loop);
  }

  loop();
});


/* ----------------------------------
  　Business 画像サイズ拡大
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
const imageObserver = new IntersectionObserver((entries) => {
  if (!location.pathname.includes('business')) return;
  entries.forEach(entry => {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
      entry.target.classList.add("is-big");
    } else {
    }
  });
}, {
  threshold: 0.7
});

document.querySelectorAll('.business_about_image').forEach(el => {
  imageObserver.observe(el);
});
});

/* ----------------------------------
  　Business　works　スライダー
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
window.addEventListener("load", () => {
  if (!location.pathname.includes('business')) return;
  const slider = document.querySelector(".business_works_slider");
  const track = slider.querySelector(".business_works_slider_content");
  let slides = Array.from(track.children);

  const originalCount = slides.length;

  // gap(px)を正確に取得
  const gapValue = getComputedStyle(track).gap;
  let gap = 0;

  if (gapValue.includes("%")) {
    const percent = parseFloat(gapValue);
    gap = (percent / 100) * slider.getBoundingClientRect().width;
  } else {
    gap = parseFloat(gapValue) || 0;
  }

  let oneLoopWidth = 0;

  slides.forEach((slide, i) => {
    oneLoopWidth += slide.getBoundingClientRect().width;
    if (i < slides.length - 1) oneLoopWidth += gap;
  });

  // 複製
  slides.forEach(slide => track.appendChild(slide.cloneNode(true)));

  let pos = 0;
  const speed = 0.6;

  function loop() {
    pos -= speed;

    if (Math.abs(pos) >= oneLoopWidth) {
      pos += oneLoopWidth;
    }

    track.style.transform = `translateX(${pos}px)`;
    requestAnimationFrame(loop);
  }

  loop();
});
});
/* ----------------------------------
  　Business　commitment アニメーション
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {

  if (!location.pathname.includes("business")) return;
  if (window.innerWidth <= 768) return;

  const allTxt = document.querySelectorAll('.business_commitment_content');
  const anim = document.querySelector('.business_commitment_animation');

  if (allTxt.length < 2 || !anim) return;

  const targetTxt_1 = allTxt[0]; //  1つ目
  const targetTxt_2 = allTxt[1]; //  2つ目

  let played = false;

  // 1つ目が見えた瞬間に透明度変更
  const observer1 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        anim.style.opacity = "0.4";
        observer1.unobserve(targetTxt_1); // 一度だけ
      }
    });
  }, {
    threshold: 0.1 // ほんの少しでも入ったらOK
  });

  observer1.observe(targetTxt_1);

  // 2つ目が完全に入ったらアニメーション
  const observer2 = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio === 1 && !played) {
        played = true;

        const rect = anim.getBoundingClientRect();
        anim.style.position = 'fixed';
        anim.style.top = rect.top + "px";
        anim.style.left = rect.left + "px";
        anim.style.width = rect.width + "px";

        requestAnimationFrame(() => {
          anim.classList.add('active');
        });

        setTimeout(() => {
          anim.classList.add('fadeout');
        }, 2000);

        observer2.unobserve(targetTxt_2);
      }
    });
  }, {
    threshold: 1.0
  });

  observer2.observe(targetTxt_2);

});



/* ----------------------------------
  　Business　works　カスタムカーソル
---------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
if (!location.pathname.includes('business')) return;
const slider = document.querySelector('.business_works_slider');
const cursor = document.querySelector('.custom_cursor');

let mouseX = 0;
let mouseY = 0;
let cx = 0;
let cy = 0;
const speed = 0.15;

// マウス座標
window.addEventListener('mousemove', e => {
  mouseX = e.clientX;
  mouseY = e.clientY;
});

// スライダー内判定 & クリック制御
function checkHover() {
  const rect = slider.getBoundingClientRect();
  const inside =
    mouseX >= rect.left &&
    mouseX <= rect.right &&
    mouseY >= rect.top &&
    mouseY <= rect.bottom;

  if (inside) {
    cursor.style.opacity = 1;
    cursor.style.pointerEvents = 'auto';
  } else {
    cursor.style.opacity = 0;
    cursor.style.pointerEvents = 'none';
  }

  requestAnimationFrame(checkHover);
}
checkHover();

// 追従
function followMouse() {
  cx += (mouseX - cx) * speed;
  cy += (mouseY - cy) * speed;

  cursor.style.transform =
    `translate(${cx - 85}px, ${cy - 85}px)`;

  requestAnimationFrame(followMouse);
}
followMouse();

});







